// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NR1v","content":"styles_content__2Mn3T"};